import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../store/hooks';
import { fetchWhatsAppNumbers } from './whatsAppMessageThunks';
import type { WhatsAppNumber } from './whatsAppMessageTypes';

/**
 * USE WHATSAPP SENDER — i numeri business della company e il mittente scelto. Lo
 * usano il modale d'invio e la pagina WhatsApp (FILO-37), così partono dallo
 * stesso mittente.
 *
 * Il mittente proposto è `preferred` (il numero della conversazione) se è ancora
 * fra quelli configurati, altrimenti il primo. Se `preferred` non c'è più,
 * `preferredUnavailable` lo dice, e la select mostra l'avviso. Registro vuoto o
 * non caricato: `sender` vuoto, e il backend usa il predefinito.
 */
export function useWhatsAppSender(preferred?: string) {
  const dispatch = useAppDispatch();
  const [numbers, setNumbers] = useState<WhatsAppNumber[]>([]);
  // La scelta dell'utente; finché non c'è vale quella proposta.
  const [chosen, setSender] = useState('');

  useEffect(() => {
    async function loadNumbers() {
      try {
        setNumbers(await dispatch(fetchWhatsAppNumbers()).unwrap());
      } catch {
        setNumbers([]);
      }
    }
    void loadNumbers();
  }, [dispatch]);

  const configured = (id?: string) => !!id && numbers.some((n) => n.phoneNumberId === id);

  const sender =
    chosen || (configured(preferred) ? preferred! : numbers[0]?.phoneNumberId ?? '');

  return {
    numbers,
    sender,
    setSender,
    preferredUnavailable: !chosen && numbers.length > 0 && !!preferred && !configured(preferred),
  };
}
